// Angular modules
import { Component }                               from '@angular/core';
import { EventEmitter }                            from '@angular/core';
import { Input }                                   from '@angular/core';
import { OnDestroy }                               from '@angular/core';
import { OnInit }                                  from '@angular/core';
import { Output }                                  from '@angular/core';
import { FormControl }                             from '@angular/forms';
import { FormGroup }                               from '@angular/forms';

// External modules
import { Subscription }                            from 'rxjs';

// Services
import { DynamicListFieldService }                 from '../dynamic-list-filed.service';

// Models
import { Filter }                                  from '../../../../../models/page.model';
import { FilterDynamicListMultipleSelectsInput }   from '../../filter-dynamic-list-multiple-selects-input.model';
import { FilterDynamicListMultipleSelectsOptions } from '../../filter-dynamic-list-multiple-selects-options.model';

@Component({
  selector    : 'app-dynamic-list-field',
  templateUrl : './dynamic-list-field-multiple-select.component.html',
  styleUrls   : ['./dynamic-list-field-multiple-selects.component.scss']
})
export class DynamicListFieldMultipleSelectsComponent implements OnInit, OnDestroy
{
  dynamicListForm : FormGroup;
  sub             : Subscription;
  showLoader = true;

  @Input() data: FilterDynamicListMultipleSelectsOptions;

  @Output() dispatchFilterValue: EventEmitter<Filter> = new EventEmitter<Filter>();

  constructor(private dynamicListFieldService: DynamicListFieldService) {}

  ngOnInit()
  {
    this.initFormGroup();
    this.setDynamicLists();
  }

  initFormGroup() : void
  {
    const group = {};
    this.data.inputs.forEach((input: FilterDynamicListMultipleSelectsInput) => {
      group[input.id] = new FormControl(null);
    });

    this.dynamicListForm = new FormGroup(group);
  }

  setDynamicLists()
  {
    this.data.inputs.forEach((input: FilterDynamicListMultipleSelectsInput) => {
      if (input.url) {
        this.sub = this.dynamicListFieldService.getDynamicList(input.url, input.sortMethod).subscribe(
          (dynamicList: Array<any>) => {
            input.display = dynamicList;
            this.showLoader = false;
          },
          () => {
            this.showLoader = false;
          },
          () => {
            this.showLoader = false;
          }
        );
      }
    });
  }

  getParentLabel(input: FilterDynamicListMultipleSelectsInput, previousLabel: string): string
  {
    previousLabel = this.dynamicListForm.get(input.id).value[input.labelToDisplay].concat(' - ', previousLabel);

    if (input.parentListId !== null) {
      return this.getParentLabel(
        this.data.inputs.find(parent => parent.id === input.parentListId),
        previousLabel
      );
    } else {
      return previousLabel.substring(0, previousLabel.length - 3);
    }
  }

  onSelectionChange(input: FilterDynamicListMultipleSelectsInput, value: any): void
  {
    if (input.filterBy) {
      const filter: Filter = {};
      filter.value = value[input.filterBy];
      filter.label = this.getParentLabel(input, '');
      filter.criteriaKey = this.data.criteriaKey;
      filter.criteriaLabel = this.data.criteriaLabel;

      this.dispatchFilterValue.emit(filter);
      this.dynamicListForm.controls[input.id].reset();
    } else {
      const childInput = this.data.inputs.find(i => i.parentListId === input.id);
      childInput.display = this.dynamicListFieldService.sortDynamicList(value[childInput.parentListProperty], childInput.sortMethod);
    }
  }

  ngOnDestroy(): void
  {
    this.sub.unsubscribe();
  }
}
